// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1045":"892254afd8ba3708","7227":"6ac0fdb5683cba41","8825":"886c0247ed6fff6a"}[chunkId] + ".css";
};